import { LanguageService } from '@app/core/service/language.service'
import { Preference } from '@app/core/model/user-preferences.interface'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { ScopeVersion } from '@app/core/model/scope-version'
import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'
import { User } from '@app/core/model/user.model'

export const getMainRoleColumns = (
  currentScope: ScopeVersion,
  user: User,
  langService: LanguageService
): Preference[] => [
  { key: TableColumnKey.ROLE_NAME, name: 'ROLE', selected: true, isVisibleInList: () => false, field: 'name' },
  {
    key: TableColumnKey.AGENCY_RATE,
    name: `${langService.get('agency')} rate`,
    selected: true,
    isVisible: () => currentScope.hasPrivilege(Privilege.SCOPE__VIEW_RATES, user),
    field: 'rateCardRate',
  },
]
